import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Grid } from "@mui/material";
import BookingReportStatus from "./BookingReportStatus";
import RentalReportStatus from "./RentalReportStatus";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import CommonTable from "components/commonTable/CommonTable";
import Loader from "components/loader/Loader";

export default function ReportsTab(props) {
  const handleChange = (event, newValue) => {
    props?.handleChange(newValue);
  };

  const handleChangePage = (event, newPage) => {
    props?.handleChangePage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    props?.handleChangeRowsPerPage(event);
  };

  const onClickTableVendor = (data) => {
    props?.onClickTableVendor(data);
  };

  const breadcrumbPaths = [
    { name: "Reports", url: "", className: "colorGrey" },
    { name: "Booking", url: "", className: "colorBlue" },
  ];

  return (
    <Grid container>
      <CommonBreadCrumb paths={breadcrumbPaths} />

      <Grid item className="tableContainer" xs={12} sx={{ marginTop: "15px" }}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className="minHeight32"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="Ride" value="Ride" className="tabStyle" />
                  <Tab label="Rental" value="Rental" className="tabStyle" />
                </TabList>
              </Grid>
              <Grid
                item
                container
                xs={6}
                spacing={4}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              ></Grid>
            </Grid>

            <TabPanel value="Ride" className="vendotTable">
              <BookingReportStatus
                titleData={props?.titleData}
                bookingData={props.bookingData}
                loaderBooking={props?.loaderBooking}
                isLoadingRideAnalytic={props?.isLoadingRideAnalytic}
                rideAnalytic={props?.rideAnalytic}
              />

              {props?.loader ? (
                <Loader />
              ) : (
                <CommonTable
                  data={props?.rideTrackData}
                  onClickTableVendor={onClickTableVendor}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={props?.page}
                  rowsPerPage={props?.rowsPerPage}
                  loader={props?.loader}
                  isClickable={true}
                />
              )}
            </TabPanel>
            <TabPanel value="Rental" className="vendotTable">
              {/* <RentalReportStatus 
                  titleData={props?.titleData} 
                /> */}
              <BookingReportStatus
                titleData={props?.titleData}
                bookingData={props.bookingData}
                loaderBooking={props?.loaderBooking}
                isLoadingRideAnalytic={props?.isLoadingRideAnalytic}
                rideAnalytic={props?.rideAnalytic}
              />
              {props?.loader ? (
                <Loader />
              ) : (
                <CommonTable
                  data={props?.rideTrackData}
                  onClickTableVendor={onClickTableVendor}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={props?.page}
                  rowsPerPage={props?.rowsPerPage}
                  isClickable={true}
                />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}
